import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const MyLineChart = ({ style, data }) => (
    <div>
        <LineChart width={style.width} height={style.height} data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <XAxis dataKey="name" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
            <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
        </LineChart>
    </div>
);

MyLineChart.defaultProps = {
    style: {
        width: 330,
        height: 150
    },
    data: []
};

export default MyLineChart;



// WEBPACK FOOTER //
// ./src/components/charts/MyLineChart.js